import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Api from "./utils/apiCall";
import { API_URLS } from "./apis/urls";

export interface ISapMasterStatus {
    id: number;
    requestStatus?: string;
    statusTitle?: string;
    created_at?: string;
    modified_at?: string;
}
interface MasterStatusState {
    masterStatus: any;
    loading: "idle" | "pending" | "fulfilled" | "rejected";
    error: string | null;
    action: "find-all-stays" | null;
}

const initialState: MasterStatusState = {
    masterStatus: null,
    loading: "idle",
    error: null,
    action: null,
};

// Async thunk to fetch SAP Master Status list
export const getAllSapMasterStatuses = createAsyncThunk(
    "get/sapMasterStatus",
    async (payload: any, thunkAPI) => {
        try {
            const response = await Api.post(API_URLS.MASTERS.FIND_ALL_STATUS, payload);
            return response.data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue(Api.getErrorMessage(error));
        }
    }
);

// Slice
const sapMasterStatusSlice = createSlice({
    name: "masterStatus",
    initialState,
    reducers: {
        resetSapMasterStatus: (state) => {
            state.loading = "idle";
            state.error = null;
            state.masterStatus = null;
            state.action = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllSapMasterStatuses.pending, (state) => {
                state.loading = "pending";
                state.masterStatus = null;
                state.error = null;
                state.action = "find-all-stays";
            })
            .addCase(getAllSapMasterStatuses.fulfilled, (state, action) => {
                state.loading = "fulfilled";
                state.masterStatus = action.payload;
                state.error = null;
                state.action = "find-all-stays";
            })
            .addCase(getAllSapMasterStatuses.rejected, (state, action) => {
                state.loading = "rejected";
                state.error = action.payload as string;
                state.masterStatus = null;
                state.action = "find-all-stays";
            });
    },
});

export const { resetSapMasterStatus } = sapMasterStatusSlice.actions;
export default sapMasterStatusSlice.reducer;
